import { memo } from "react";
import { TMessageForm } from "../messagesSchema";
import { AutoComplete, ISelectType, useFormContext } from "@4uhub/lib4uhub";
import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";
import MainApi from "../../../../../../../services/mainApi.service";

const TICKET_CHANNEL_ROUTE =
  process.env.REACT_APP_TICKETS + "/api/v1/TicketChannels/";
const ticketChannelService = new MainApi<ISelectType>(TICKET_CHANNEL_ROUTE);

const translationPath = "page.4uMarCom.automationRules.marcom_message.";

interface ITicketChannelMessagesMarcomProps {
  name?: "ticketChannel" | "ticketChannelWhenNotIdentified";
  stepFieldName?: "ticketChannelStep" | "ticketChannelStepWhenNotIdentified";
}

export const TicketChannelMessagesMarcom = memo(
  ({
    name = "ticketChannel",
    stepFieldName = "ticketChannelStep",
  }: ITicketChannelMessagesMarcomProps) => {
  const { t } = useTranslation();

  const { setValue } = useFormContext<TMessageForm>();

  return (
    <Grid item xs={12} sm={6}>
      <AutoComplete
        getOptionLabel={({ name }) => name}
        size="small"
        label={t(translationPath + "ticket_channel")}
        name={name}
        request={ticketChannelService.list}
        onValueChange={() => {
          setValue(stepFieldName, null);
        }}
      />
    </Grid>
  );
  },
);
